<template>
  <BaseModal
    name="planEventsModal"
    width="560"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="() => {}"
    @before-open="loadData"
    :adaptive="true"
    height="auto"
    classes="!tw-bg-transparent !tw-shadow-none"
  >
    <div
      class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
    >
      <button
        type="button"
        class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
        @click="$modal.hide('planEventsModal')"
      ></button>

      <BaseLoader
        v-if="localLoading"
        style="z-index: 1000"
        class="tw-rounded-[25px]"
      ></BaseLoader>

      <div class="tw-text-[23px] tw-mb-[15px] tw-text-center">
        Запланированные события
      </div>

      <div style="max-height: 450px; overflow-y: auto; width: 100%">
        <ve-table
          style="width: 100%"
          :columns="columns"
          :table-data="dataTable"
          :border-x="true"
          :border-y="true"
          class="ve-table-hide"
          row-key-field-name="vehicle_interval_event_plans__id"
          ref="mainTable"
          :eventCustomOption="eventCustomOption"
          :checkbox-option="checkboxOption"
          :clickHighlight="false"
          :cell-style-option="cellStyleOption"
          :editOption="editOption"
          :rowStyleOption="{
            hoverHighlight: false,
          }"
          :cellSelectionOption="{ enable: true }"
        />
      </div>
    </div>

    <BaseModal
      name="deletePlanEventModal"
      width="420"
      height="320"
      :clickToClose="false"
      :shiftY="0.5"
      :adaptive="true"
      classes="!tw-bg-transparent !tw-shadow-none"
    >
      <div
        class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
      >
        <button
          type="button"
          class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
          @click="$modal.hide('deletePlanEventModal')"
        ></button>

        <div class="tw-text-[23px] tw-mb-[15px] tw-text-center">
          Точно удалить?
        </div>

        <div class="tw-h-[10px]"></div>

        <div class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center">
          <button
            @click="closeDeleteConfirmModal"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            Отменить
          </button>
          <button
            @click="onConfirmDelete"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            Подтверждаю
          </button>
        </div>
      </div>
    </BaseModal>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import GeneralService from "@/api/GeneralService.js";
import dayjs from "dayjs";
import { VeTable } from "vue-easytable";
import EventBus from "@/event-bus.js";

export default {
  components: {
    VeTable,
  },
  props: {},
  data() {
    return {
      localLoading: true,
      updatedValues: [],
      dataTable: [],
      innerWidth: window.innerWidth,
      activeSelectRowsMultiple: [],
      pincode: null,
      pendingDeleteId: null,
      messageError: "",
      id: null,
      checkboxOption: {
        hideSelectAll: true,
        // row select change event
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.activeSelectRowsMultiple = selectedRowKeys;
        },
        // selected all change event
        selectedAllChange: ({ row, isSelected, selectedRowKeys }) => {
          this.activeSelectRowsMultiple = selectedRowKeys;
        },
      },
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              // this.$modal.show('EditsTariffModal', {
              //   id: row.tariff_for_car__id
              // })
            },
          };
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (
            column.field ===
            Object.keys(row.settings).find((x) => x == column.field)
          ) {
            return row.settings[column.field];
          }
        },
      },
      editOption: {
        beforeStartCellEditing: ({ row, column, cellValue }) => {
          // if (row.tariff_groups_for_car__is_eternal) {
          //   if (this.userSetting.company_lc == 1) {
          //     return true
          //   } else {
          //     return false
          //   }
          // }
          // return true
        },
        beforeCellValueChange: ({ row, column, changeValue }) => {
          // if (
          //   (column.field !== 'tariff_groups_for_car__name') ==
          //   !/^\d+$/.test(changeValue)
          // ) {
          //   this.$toast.error('Для ввода доступны только цифры', { duration: 5000 })
          //   return false
          // }
        },
        cellValueChange: ({ row, column }) => {
          // let indexed = this.updatedValues.findIndex(
          //   (x) => x.id == row.tariff_groups_for_car__id
          // )
          // if (indexed !== -1) {
          //   this.updatedValues[indexed][column.field] =
          //     column.field == 'tariff_groups_for_car__name'
          //       ? row[column.field]
          //       : Number(row[column.field])
          // } else {
          //   this.updatedValues.push({
          //     id: row.tariff_groups_for_car__id,
          //     [column.field]:
          //       column.field == 'tariff_groups_for_car__name'
          //         ? row[column.field]
          //         : Number(row[column.field])
          //   })
          // }
        },
      },
    };
  },
  methods: {
    loadData(payload) {
      // payload may come from modal (@before-open) as { params: { id } }
      const params =
        payload && payload.params ? payload.params : { id: this.id };
      this.localLoading = true;
      this.id = params.id || this.id;

      GeneralService.get(`/object_interval_events_plan/${this.id}`)
        .then((response) => {
          const rows =
            response &&
            response.data &&
            response.data.data &&
            response.data.data.rows
              ? response.data.data.rows
              : [];

          const getSeverity = (row) => {
            const vals = Object.values(row.settings || {});
            if (vals.includes("cell-status-red")) return 2;
            if (vals.includes("cell-status-orange")) return 1;
            return 0;
          };

          // sort: reds first, then oranges, then others; within each group sort by date, then km, then motohour
          rows.sort((a, b) => {
            const sa = getSeverity(a);
            const sb = getSeverity(b);
            if (sa !== sb) return sb - sa; // higher severity first (2 -> 1 -> 0)

            const ad = a.vehicle_interval_event_plans__day
              ? dayjs(a.vehicle_interval_event_plans__day).valueOf()
              : Number.POSITIVE_INFINITY;
            const bd = b.vehicle_interval_event_plans__day
              ? dayjs(b.vehicle_interval_event_plans__day).valueOf()
              : Number.POSITIVE_INFINITY;
            if (ad !== bd) return ad - bd;

            const ak =
              a.vehicle_interval_event_plans__km != null
                ? Number(a.vehicle_interval_event_plans__km)
                : Number.POSITIVE_INFINITY;
            const bk =
              b.vehicle_interval_event_plans__km != null
                ? Number(b.vehicle_interval_event_plans__km)
                : Number.POSITIVE_INFINITY;
            if (ak !== bk) return ak - bk;

            const am =
              a.vehicle_interval_event_plans__motohour != null
                ? Number(a.vehicle_interval_event_plans__motohour)
                : Number.POSITIVE_INFINITY;
            const bm =
              b.vehicle_interval_event_plans__motohour != null
                ? Number(b.vehicle_interval_event_plans__motohour)
                : Number.POSITIVE_INFINITY;
            return am - bm;
          });

          this.dataTable = rows;
          this.localLoading = false;
        })
        .catch((e) => {
          this.localLoading = false;
          this.$toast.error(
            e.response && e.response.data && e.response.data.message
              ? e.response.data.message
              : "Ошибка",
            { duration: 5000 }
          );
        });
    },
    openDeleteConfirmModal(vehicle_interval_event_plans__id) {
      this.pendingDeleteId = vehicle_interval_event_plans__id;
      this.$modal.show("deletePlanEventModal");
    },
    closeDeleteConfirmModal() {
      this.pendingDeleteId = null;
      this.$modal.hide("deletePlanEventModal");
    },
    onConfirmDelete() {
      if (!this.pendingDeleteId) {
        this.$toast.error("Выберите хотя бы одно поле", { duration: 5000 });
        return;
      }

      const deleteId = this.pendingDeleteId;
      this.closeDeleteConfirmModal();
      this.deleteGroup(deleteId);
    },
    deleteGroup(vehicle_interval_event_plans__id) {
      if (vehicle_interval_event_plans__id) {
        GeneralService.delete(
          `/object_interval_events_plan/${this.id}/${vehicle_interval_event_plans__id}`,
          {
            ...(this.pincode && { pincode: this.pincode }),
          }
        )
          .then(() => {
            EventBus.$emit("contentLoaded");
            EventBus.$emit("updateContentData");
            // hide the confirmation modal we opened before deleting
            try {
              this.$modal.hide("deletePlanEventModal");
            } catch (err) {}
            this.loadData();
          })
          .catch((e) => {
            const status = e && e.response && e.response.status;
            const data = e && e.response && e.response.data;
            if (status == 409) {
              // need pincode confirmation - hide delete modal and show pin modal
              try {
                this.$modal.hide("deletePlanEventModal");
              } catch (err) {}
              this.$modal.show("acceptDeleteWithPin");
              this.messageError = data && data.message ? data.message : "";
              this.$toast.error(this.messageError || "Ошибка", {
                duration: 5000,
              });
            } else if (status == 400) {
              this.messageError = data && data.message ? data.message : "";
              this.$toast.error(this.messageError || "Ошибка", {
                duration: 5000,
              });
              try {
                this.$modal.hide("acceptDeleteWithPin");
              } catch (err) {}
            }
          });
      } else {
        this.$toast.error("Выберите хотя бы одно поле", { duration: 5000 });
      }
    },
    beforeClose(event) {
      this.currentOpened = null;
      this.dataForModal = {};
      this.updatedValues = {};
      this.activeSelectRowsMultiple = [];
    },
    updateValue(data) {
      this.updatedValues[data.name] = data.value;
      //   this.$refs[data.name].classList.remove('input-error')
    },
    pincodeModalHandler() {
      this.pincode = "";
      this.messageError = "";
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),

    columns() {
      return [
        {
          field: "vehicle_interval_event_plans__name",
          key: "1",
          title: "Событие",
          align: "center",
          width: "24%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },

        {
          field: "vehicle_interval_event_plans__km",
          key: "25",
          title: "Пробег",
          align: "center",
          width: "24%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "vehicle_interval_event_plans__motohour",
          key: "22331",
          title: "Моточасы",
          align: "center",
          width: "24%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "vehicle_interval_event_plans__day",
          key: "32",
          title: "Дата",
          align: "center",
          width: "24%",

          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.vehicle_interval_event_plans__day
                  ? this.$time(row.vehicle_interval_event_plans__day).format(
                      `${this.userSetting.company__tempalte_date}`
                    )
                  : ""}
              </span>
            );
          },
        },
        {
          field: "",
          key: "4231",
          title: "",
          align: "left",
          width: "4%",

          ellipsis: {
            showTitle: true,
          },
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <svg
                class="cursor-pointer"
                onClick={() => {
                  this.openDeleteConfirmModal(
                    row.vehicle_interval_event_plans__id
                  );
                }}
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.77731 0.64618C1.46489 0.33376 0.958355 0.33376 0.645936 0.64618C0.333516 0.958599 0.333516 1.46513 0.645936 1.77755L6.86848 8.00009L0.645936 14.2226C0.333517 14.5351 0.333517 15.0416 0.645936 15.354C0.958357 15.6664 1.46489 15.6664 1.77731 15.354L7.99985 9.13146L14.2223 15.3539C14.5347 15.6663 15.0412 15.6663 15.3537 15.3539C15.6661 15.0415 15.6661 14.535 15.3537 14.2225L9.13122 8.00009L15.3538 1.77755C15.6662 1.46513 15.6662 0.958599 15.3538 0.64618C15.0413 0.33376 14.5348 0.33376 14.2224 0.64618L7.99985 6.86872L1.77731 0.64618Z"
                  fill="#FF3A20"
                />
              </svg>
            );
          },
        },
      ];
    },
    //     {
    //     "sms_presets__category_id": 2,
    //     "sms_presets__company_id": 2,
    //     "sms_presets__created_at": "2024-01-19 08:36:52",
    //     "sms_presets__id": 6,
    //     "sms_presets__name": "третий",
    //     "sms_presets__text": "Не пользуйтесь нашими услугами",
    //     "sms_presets__updated_at": "2024-01-19 11:36:52"
    // }
  },
};
</script>
